import React from 'react'
import { withIcon } from '../../withIcon'

function ThumbDownSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M19.1824 4L10.7801 4C10.7143 4 10.6479 4.00672 10.5834 4.02035C8.1957 4.5254 8.68238 5.47381 8.68238 8.5V12.5711C8.68238 12.808 8.87448 13 9.11146 13C9.15842 13 9.20444 13.0075 9.24865 13.0233C9.52461 13.122 10.5953 13.523 11.1824 14C11.9401 14.6157 12.2695 15.1153 12.6824 16C12.8773 16.4177 13.1824 17.1193 13.1824 18.5C13.1824 19.622 13.9783 20 14.6824 20C15.6824 20 16.2919 19.281 16.6824 18.5C17.1017 17.6614 16.8177 15.7681 16.7152 13.9993C16.6832 13.4479 17.1291 13.0216 17.6799 13.0626C19.2239 13.1776 21.6824 13.303 21.6824 12C21.6824 10.3379 20.1824 4 19.1824 4Z" fill={color}/>
      <path d="M3 4.5C2.26598 4.5 1.95025 12.5 2.95032 13C3.87529 13.4625 5.32864 13.3126 6.20539 13.1585C6.64887 13.0805 6.95214 12.6879 6.95478 12.2376L6.99412 5.50584C6.99736 4.95128 6.54853 4.5 5.99396 4.5L3 4.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ThumbDownSolidIcon)
